import type React from 'react'

import { Top1 } from './Top1'
import { Top2 } from './Top2'
import { Top3 } from './Top3'
import { Top4 } from './Top4'
import { Top5 } from './Top5'
import { Top6 } from './Top6'
import { Top7 } from './Top7'
import { Top8 } from './Top8'
import { Top9 } from './Top9'
import { Top10 } from './Top10'

export const topNumberToPicture: Record<number, () => React.ReactNode> = {
  1: Top1,
  2: Top2,
  3: Top3,
  4: Top4,
  5: Top5,
  6: Top6,
  7: Top7,
  8: Top8,
  9: Top9,
  10: Top10,
}
